import { render, staticRenderFns } from "./CivilCasesNew.vue?vue&type=template&id=57245e25&"
import script from "./CivilCasesNew.vue?vue&type=script&lang=js&"
export * from "./CivilCasesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports